import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSaveRoutine } from './_requests/saveRoutine'
import { useRoutine } from './_load/RoutineLoader'
import FolderAndNameSection from './form/FolderAndNameSection'
import Form from '../../../packages/kiti/components/form/form/Form'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import ServiceOrdersSection from './form/ServiceOrdersSection'
import FrequencySection from './form/FrequencySection'
import { useFormStateFormatter } from '../../triggers/editV2/_helpers/formatFormState'
import Separator from '../../../components/helpers/Separator'

const Wrapper = () => {
  const { t } = useTranslation('routines')
  const routine = useRoutine() || {}
  const [onSubmit, { loading, error }] = useSaveRoutine()

  const getFrequencyTypeFromCronExpression = cronExpression => {
    if (!cronExpression) return { id: 'day', name: t('frequencyOptions.day') }
    if (routine.frequency.split(' ')[3] !== '*' && routine.frequency.split(' ')[4] === '*')
      return { id: 'year', name: t('frequencyOptions.year') }

    if (routine.frequency.split(' ')[4] !== '*') return { id: 'week', name: t('frequencyOptions.week') }
    return { id: 'day', name: t('frequencyOptions.day') }
  }

  const frequencyType = getFrequencyTypeFromCronExpression(routine.frequency)

  const formState = useFormStateFormatter({
    ...routine,
    action: 'create_bulk_service_orders_with_parent',
    name: routine.name,
    frequencyIndex: routine.frequencyIndex || 1,
    frequencyType,
    weekday: frequencyType.id === 'week' ? Number(routine.frequency.split(' ')[4]) : null,
    initialDate: !!routine.initialDate ? routine.initialDate : new Date().setDate(new Date().getDate() + 1),
    until: !!routine.until ? routine.until : 'never'
  })

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={formState}>
      <FolderAndNameSection />
      <Separator weight={4} />
      <ServiceOrdersSection />
      <FrequencySection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default Wrapper
